import { SupplierWorktimeControlDocument } from './supplier-worktime-control-document';

export class SupplierWorktime {
    public supplierID: string;
    public supplierWorktimeID: string;
    public worktimeStart: Date;
    public worktimeEnd: Date;
    public supplierRegionID: string;
    public supplierRegionName: string;
    public supplierWorktimeControlDocumentList: SupplierWorktimeControlDocument[];
}
